@let parameterSetsValue = parameterSets();
@let isMobilePlatformValue = isMobilePlatform();
@let parameterSetValue = parameterSet();
@let userParametersetsValue = userParametersets();
<mat-drawer-container autosize>
  <!-- Settings -->
  <mat-drawer #drawer mode="over" position="end">
    <button mat-icon-button class="close-button" (click)="drawer.toggle()">
      <fa-icon [icon]="['far', 'times']"></fa-icon>
    </button>
    <ng-container *ngTemplateOutlet="eppSettings"></ng-container>
  </mat-drawer>
  <div class="base-container">
    <a id="start"></a>
    @let selectedStationListItemValue = selectedStationListItem();
    @let selectedResolutionValue = selectedResolution();
    @let selectedViewValue = selectedView();
    <form [formGroup]="panelForm">
      <!-- PANEL -->
      <div class="panel">
        @let showMobileFormFieldsValue = showMobileFormFields();
        @if (isMobilePlatformValue && !showMobileFormFieldsValue) {
          <div
            style="display: flex; justify-content: space-between; width: 100%">
            <button mat-button (click)="showMobileFormFields.set(true)">
              @if (selectedStationListItemValue | isNil: false) {
                {{ selectedStationListItemValue.overwriteStationName }}
              } @else {
                --
              }
              &nbsp; | &nbsp;
              {{
                'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterSetValue | translate
              }}
            </button>
            <button mat-icon-button (click)="showMobileFormFields.set(true)">
              <fa-icon [icon]="['fal', 'chevron-down']"></fa-icon>
            </button>
          </div>
        }
        @if (!isMobilePlatformValue || showMobileFormFieldsValue) {
          @if (isMobilePlatformValue) {
            <button
              mat-icon-button
              (click)="showMobileFormFields.set(false)"
              style="position: absolute; right: 0px; top: 20px; z-index: 10">
              <fa-icon [icon]="['fal', 'chevron-up']"></fa-icon>
            </button>
          }
          <!-- Master Station Search -->
          <app-global-station-search-bar
            (selectedStation)="
              onGlobalStationSelect($event.name, $event.id, $event.elevation)
            "></app-global-station-search-bar>
          <!-- STATION SELECT -->

          @if (hasBetweenOneAndSixStations()) {
            <mat-form-field appearance="fill" class="station-select">
              <mat-label>{{
                'PRODUCT.EPP.SELECTSTATION' | translate
              }}</mat-label>
              <mat-select
                formControlName="stationListItem"
                placeholder="{{ 'PRODUCT.EPP.SELECTSTATION' | translate }}"
                (selectionChange)="onStationChange($event)">
                @for (station of stationList(); track $index) {
                  <mat-option [value]="station">
                    @if (station.stationId | isSolarpowerStation) {
                      <fa-icon [icon]="['fal', 'sun']"></fa-icon>
                    }
                    @if (station.stationId | isWindpowerStation) {
                      <fa-icon [icon]="['fal', 'wind-turbine']"></fa-icon>
                    }
                    {{ station.overwriteStationName }}
                    <!-- Elevation of Station -->
                    @if (station.hasOwnProperty('elevation')) {
                      <small> | {{ station?.elevation }} m </small>
                    }
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          } @else if (hasMoreThanFiveStations()) {
            <mat-form-field appearance="fill" class="station-select">
              <mat-label>{{
                'PRODUCT.EPP.SEARCHSTATION' | translate
              }}</mat-label>
              <input
                type="text"
                matInput
                formControlName="stationListItem"
                placeholder="{{ 'PRODUCT.EPP.SEARCHSTATION' | translate }}"
                appResetInputMatAutocomplete
                [previousSelectedControlValue]="selectedStationListItemValue"
                [matAutocomplete]="stationsAutocomplete" />
              <mat-icon matSuffix>search</mat-icon>
              <mat-autocomplete
                #stationsAutocomplete="matAutocomplete"
                [displayWith]="displayStationName"
                (optionSelected)="onStationChange($event)">
                @for (
                  station of stationListFilteredOptions$ | async;
                  track $index
                ) {
                  <mat-option [value]="station">
                    @if (station.stationId | isSolarpowerStation) {
                      <fa-icon [icon]="['fal', 'sun']"></fa-icon>
                    }
                    @if (station.stationId | isWindpowerStation) {
                      <fa-icon [icon]="['fal', 'wind-turbine']"></fa-icon>
                    }
                    {{ station.overwriteStationName }}
                    <!-- Elevation of Station -->
                    @if (station.hasOwnProperty('elevation')) {
                      <small> | {{ station?.elevation }} m </small>
                    }
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          } @else if (selectedStationListItemValue) {
            <div class="station-static-label">
              {{ selectedStationListItemValue.overwriteStationName }}
              @if (selectedStationListItemValue.hasOwnProperty('elevation')) {
                <small>
                  | {{ selectedStationListItemValue?.elevation }} m
                </small>
              }
            </div>
          }

          <!-- Parameterset Select -->
          @if (parameterSetsValue.length > 1) {
            <mat-form-field appearance="fill" class="parameterset-select">
              <mat-label>{{
                'PRODUCT.EPP.PARAMETERSET.SELECT' | translate
              }}</mat-label>
              <mat-select
                formControlName="parameterSet"
                placeholder="{{
                  'PRODUCT.EPP.PARAMETERSET.SELECT' | translate
                }}"
                (selectionChange)="onParameterSetChange($event)">
                @for (parameterSet of parameterSetsValue; track $index) {
                  <mat-option [value]="parameterSet">
                    {{
                      'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterSet
                        | translate
                    }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <!-- View Select -->
          @for (view of views(); track $index) {
            <button
              mat-button
              [ngClass]="
                selectedViewValue === view
                  ? 'parameter-button button-active'
                  : 'parameter-button'
              "
              (click)="onViewChange(view)"
              [matTooltip]="'PRODUCT.EPP.VIEW.' + view | translate">
              <fa-icon [icon]="['far', viewIcons[view]]"></fa-icon>
            </button>
          }
          &nbsp;
          @let lastIssueTimeValue = lastIssueTime();
          @let savedLastIssueTimeValue = savedLastIssueTime();
          @if (lastIssueTimeValue && savedLastIssueTimeValue) {
            <button
              mat-button
              class="status-button"
              (click)="onRefreshEpp()"
              [matTooltip]="'PRODUCT.EPP.RELOAD' | translate">
              {{ 'PRODUCT.EPP.LAST_UPDATE' | translate }}:
              {{
                savedLastIssueTimeValue
                  | datex: 'HH:mm' : undefined : languageService.langSignal()
              }}
              &nbsp;
              <fa-icon [icon]="['far', 'redo']"></fa-icon>
            </button>
          }
        }
      </div>
    </form>

    <div style="min-height: calc(100vh - 170px)">
      @let eppDataValue = eppData();
      @if (eppDataValue && eppDataValue[parameterSetValue]) {
        @let currentResolutionKey = toResolutionKey(selectedResolutionValue);
        @let userParametersForTableValue =
          userParametersetsValue[currentResolutionKey]?.[parameterSetValue];

        <mat-tab-group
          [selectedIndex]="tabsSelectedIndex()"
          (selectedTabChange)="onTabChanged($event)"
          dynamicHeight>
          @for (resolution of resolutions(); track $index) {
            <mat-tab>
              <ng-template mat-tab-label>
                <strong>{{ resolution['days'] }}</strong> &nbsp;
                {{ 'PRODUCT.EPP.RESOLUTION.DAYS' | translate }}
                <small>
                  &nbsp; ({{
                    'PRODUCT.EPP.RESOLUTION.HOURLY.' + resolution['hourly']
                      | translate
                  }})</small
                >
              </ng-template>

              <ng-template matTabContent>
                <mat-card appearance="outlined" class="table-card">
                  @let savedEppDataValue = savedEppData();
                  @if (!loadingData() && savedEppDataValue) {
                    @let defaultParametersetDetailsValue =
                      defaultParametersetDetails();
                    @let tableParameterChangedValue = tableParameterChanged();
                    @if (selectedViewValue === 'TABLE') {
                      <app-epp-table
                        [tableData]="savedEppDataValue"
                        [parameterDefinitions]="
                          defaultParametersetDetailsValue[parameterSetValue]
                        "
                        [userParameters]="userParametersForTableValue"
                        [parameterset]="parameterSetValue"
                        [parameterChanged]="tableParameterChangedValue"
                        [resolution]="selectedResolutionValue"
                        (columnOrderChanged)="
                          onTableColumnOrderChanged(
                            $event,
                            selectedResolutionValue,
                            parameterSetValue
                          )
                        "
                        (headerContextMenu)="
                          onTableHeaderContextMenu(
                            $event,
                            selectedResolutionValue,
                            parameterSetValue
                          )
                        ">
                      </app-epp-table>
                    }
                    @if (selectedViewValue === 'METEOGRAM') {
                      <div class="meteogram-container">
                        @let meteogramDataValue = meteogramData();
                        @if (meteogramDataValue) {
                          <!-- meteogram -->
                          <app-epp-meteogram
                            [eppData]="meteogramDataValue"
                            [rebuild]="rebuildMeteogram()"
                            [parameterDefinitions]="
                              defaultParametersetDetailsValue[parameterSetValue]
                            "
                            [userParameters]="
                              userParametersetsValue[currentResolutionKey]?.[
                                parameterSetValue
                              ]
                            "
                            [parameterset]="parameterSetValue"
                            [resolution]="
                              selectedResolutionValue
                            "></app-epp-meteogram>
                        }
                        @if (
                          userParametersetsValue[currentResolutionKey]?.[
                            parameterSetValue
                          ]?.length > 0 && meteogramDataValue
                        ) {
                          <!-- index matrix -->
                          <app-epp-matrix
                            [parameterType]="'index'"
                            [parametersetName]="parameterSetValue"
                            [tableData]="savedEppDataValue"
                            [userParameters]="
                              userParametersetsValue[currentResolutionKey]?.[
                                parameterSetValue
                              ]
                            "
                            [parameterChanged]="tableParameterChangedValue"
                            [parameterDefinitions]="
                              defaultParametersetDetailsValue[parameterSetValue]
                            "
                            [resolution]="
                              selectedResolutionValue
                            "></app-epp-matrix>

                          <!-- condition matrix -->
                          <app-epp-matrix
                            [parameterType]="'condition'"
                            [parametersetName]="parameterSetValue"
                            [tableData]="savedEppDataValue"
                            [userParameters]="
                              userParametersetsValue[currentResolutionKey]?.[
                                parameterSetValue
                              ]
                            "
                            [parameterChanged]="tableParameterChangedValue"
                            [parameterDefinitions]="
                              defaultParametersetDetailsValue[parameterSetValue]
                            "
                            [resolution]="
                              selectedResolutionValue
                            "></app-epp-matrix>
                        }
                      </div>
                    }
                  } @else {
                    <app-loading-overlay
                      text="Daten werden geladen..."
                      [fullScreen]="false">
                    </app-loading-overlay>
                  }
                </mat-card>
              </ng-template>
            </mat-tab>
          }
          @if (
            selectedStationListItemValue.stationId
              | hasUserSmw
                : auth.isMaster()
                : auth.getCustomerAlias()
                : auth.getCustomerDocument()
                : auth.hasUserWebAccess()
                : auth.getUserProfile()?.['metadata']
                : false
          ) {
            <mat-tab (click)="onSmw()">
              <ng-template mat-tab-label>
                <fa-icon [icon]="['far', 'external-link']"></fa-icon>&nbsp;
                {{ 'PRODUCT.SMW.TITLE' | translate }}
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      }
      @if (false) {
        <pre>
          {{ parameterSetValue }}
          {{ userParametersetsValue | json }}
        </pre>
      }
    </div>
  </div>

  <!-- SIDENAV SETTINGS -->
  <div class="settings-button-stack">
    <!--settings button-->
    <button
      mat-mini-fab
      class="settings-button"
      (click)="onSetupSettings(); drawer.toggle()"
      tp="{{ 'HOME.SETTINGS' | translate }}"
      variation="popper"
      trigger="mouseenter"
      tpPlacement="left">
      <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon>
    </button>
    <!--info button-->
    <button
      mat-mini-fab
      #infoButton
      class="settings-button"
      tp="{{ 'PRODUCT.EPP.INFO' | translate }}"
      variation="popper"
      appendTo="parent"
      trigger="mouseenter"
      tpPlacement="left">
      <fa-icon [icon]="['far', 'info-circle']" size="lg"></fa-icon>
    </button>
    <button
      mat-mini-fab
      class="settings-button palette-toggle-button"
      [class.palette-toggle-button--active]="neutralColor() === 'green'"
      (click)="onToggleColor(neutralColor() !== 'green')"
      [matTooltip]="
        (neutralColor() === 'green'
          ? 'PRODUCT.EPP.SETTINGS.COLOR.GREEN'
          : 'PRODUCT.EPP.SETTINGS.COLOR.WHITE'
        ) | translate
      "
      tpPlacement="left">
      <fa-icon [icon]="['far', 'palette']" size="lg"></fa-icon>
    </button>
  </div>
</mat-drawer-container>

<!-- Settings-->
<ng-template #eppSettings>
  <app-epp-settings
    [parameterSets]="parameterSetsValue"
    [resolutions]="resolutions()"
    [selectedResolution]="selectedResolutionValue"
    [settingsParametersByResolutionAndSet]="
      settingsParametersByResolutionAndSet()
    "
    [isMobilePlatform]="isMobilePlatformValue"
    (restoreStandardSettings)="onRestoreStandardSettings()"
    (cancelSettings)="onCancelSettings(); drawer.toggle()"
    (saveSettings)="onSaveSettings(); drawer.toggle()"
    (drop)="onDrop($event.event, $event.resolution, $event.parameterset)"
    (parameterSelectionChange)="
      onParameterSelectionChange(
        $event.event,
        $event.resolution,
        $event.parameterset
      )
    "
    (selectAllChange)="
      toggleSelectAll($event.checked, $event.resolution, $event.parameterset)
    "></app-epp-settings>
</ng-template>
